import { ActiveFiltersType } from '@bytel/product-wall';
import { countActiveFilters } from '@bytel/product-wall/helpers';
import { FilterTypeEnum } from '@bytel/product-wall/types';

import { getAppConfig } from '@services/config';
import { cmsHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';

import { WallConfigType } from '@app-types/config';

import { FaqSlugType, PAGE_SLUG } from '@helpers/partials';

const appConf = getAppConfig();

export const getAccordionSeo = async (
    wallConfig: WallConfigType,
    activeFilters: ActiveFiltersType = {},
): Promise<string | undefined> => {
    const genericAccordionUrl = PAGE_SLUG.PHONE_WALL;
    let url: FaqSlugType = genericAccordionUrl;

    if (countActiveFilters(activeFilters) === 1) {
        const [key, value] = Object.entries(activeFilters)[0] as [string, string[]];
        let urlKey: string | undefined;
        const filter = wallConfig.filtersObject[key];
        if (filter?.type === FilterTypeEnum.CHECKBOX_LIST) {
            urlKey = Object.values(filter.values ?? {}).find((v) => v.value === value[0])?.urlKey;
        } else if (filter?.type === FilterTypeEnum.CHECKBOX) {
            urlKey = filter.urlKey;
        }
        url = urlKey ? (`${genericAccordionUrl}_filtre_${urlKey}` as FaqSlugType) : genericAccordionUrl;
    }

    return (await accordionSeoApi(url)) ?? (await accordionSeoApi(genericAccordionUrl));
};

const accordionSeoApi = async (url: FaqSlugType): Promise<string | undefined> => {
    const baseUrl = `${appConf.assets.partials.url}/faq/emplacements/`;

    return cmsHttpService
        .get<string | undefined>(`${baseUrl}/${url}`, undefined, {
            ttl: Number.parseInt(getAppConfig().cache.ttl.cms),
            tags: [CACHE_TAGS.CMS],
        })
        .catch(() => undefined);
};
